import z from "zod";
export const SentryTraceHeaders = z.object({
    sentryTrace: z.string(),
    baggage: z.string(),
});
